import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Meta, MetaState } from '@df/core/meta/meta';
import { NFacetUrl } from '@df/module-facet-url/core/facet.interfaces';
import mapKeys from 'lodash-es/mapKeys';
import omit from 'lodash-es/omit';

/**
 * Plugin for meta data
 */
@Injectable({
    providedIn: 'root'
})
export class FacetUrlMetaPluginService {
    protected meta = inject(Meta);
    protected destroyRef = inject(DestroyRef);

    appInitialize() {
        this.patchMetaState();
    }

    private patchMetaState() {
        this.meta.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
            const facetData = this.patchFacetData(state?.route?.data?.facet);

            if (facetData && state) {
                this.onMetaStateChange(state, facetData);
            }
        });
    }

    protected patchFacetData(facetData?: NFacetUrl.IFacetData) {
        return facetData;
    }

    protected onMetaStateChange(state: MetaState, facetData: NFacetUrl.IFacetData) {
        const metaData = {
            ...state.metaData,
            ...mapKeys(
                omit(facetData, 'id', 'category', 'filter', 'h1'),
                (value, key) => 
                    ({
                        meta_title: 'title',
                        meta_description: 'description'
                    }[key] || key)
            )
        };

        state.metaData = metaData;
    }
}
